import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { ToastContainer } from 'react-toastify';
import CssBaseline from '@mui/material/CssBaseline';
import NovaMatch from './pages/NovaMatch';
import MonitoringDashboard from './pages/MonitoringDashboard';
import LoginHistory from './pages/LoginHistory';
import Login from './pages/Login';
import Register from './pages/Register';
import Setup2FA from './pages/Setup2FA';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ChangePassword from './pages/ChangePassword';
import VerifyEmail from './pages/VerifyEmail';
import LandingPage from './pages/LandingPage';
import Billing from './pages/Billing';
import Payment from './pages/Payment';
import Invoice from './pages/Invoice';
import Support from './pages/Support';
import SsoCallback from './pages/SsoCallback';
import ProtectedRoute from './components/ProtectedRoute';
import PublicLayout from './components/layout/PublicLayout';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import SessionManager from './components/SessionManager';
import { appleTheme } from './theme/appleTheme';

function App() {
  // Right-click and developer tools are now allowed in production
  // Security measures have been implemented at the backend level

  const router = createBrowserRouter([
    { 
      path: '/', 
      element: (
        <PublicLayout>
          <LandingPage />
        </PublicLayout>
      ) 
    },
    { 
      path: '/register', 
      element: (
        <PublicLayout>
          <Register />
        </PublicLayout>
      ) 
    },
    { 
      path: '/login', 
      element: (
        <PublicLayout>
          <Login />
        </PublicLayout>
      ) 
    },
    { 
      path: '/forgot-password', 
      element: (
        <PublicLayout>
          <ForgotPassword />
        </PublicLayout>
      ) 
    },
    { path: '/verify-email/:token', element: <VerifyEmail /> },
    { path: '/setup-2fa', element: <Setup2FA /> },
    { path: '/reset-password/:token', element: <ResetPassword /> },
    { path: '/sso', element: <SsoCallback /> },
    {
      path: '/change-password',
      element: (
        <ProtectedRoute>
          <ChangePassword />
        </ProtectedRoute>
      ),
    },
    {
      path: '/app',
      element: (
        <ProtectedRoute>
          <NovaMatch />
        </ProtectedRoute>
      ),
    },
    {
      path: '/dashboard',
      element: (
        <ProtectedRoute>
          <MonitoringDashboard />
        </ProtectedRoute>
      ),
    },
    {
      path: '/login-history',
      element: (
        <ProtectedRoute>
          <LoginHistory />
        </ProtectedRoute>
      ),
    },
    {
      path: '/billing',
      element: (
        <ProtectedRoute>
          <Billing />
        </ProtectedRoute>
      ),
    },
    {
      path: '/payment',
      element: (
        <ProtectedRoute>
          <Payment />
        </ProtectedRoute>
      ),
    },
    {
      path: '/invoice',
      element: (
        <ProtectedRoute>
          <Invoice />
        </ProtectedRoute>
      ),
    },
    {
      path: '/support',
      element: (
        <ProtectedRoute>
          <Support />
        </ProtectedRoute>
      ),
    },
  ]);

  return (
    <ThemeProvider theme={appleTheme}>
      <CssBaseline />
      <div className="App">
        <RouterProvider router={router} future={{ v7_startTransition: true, v7_relativeSplatPath: true }} />
        <ToastContainer />
        <SessionManager />
      </div>
    </ThemeProvider>
  );
}

export default App;
